'use strict';

exports.__esModule = true;
exports.TableView = exports.styles = undefined;

var _class, _temp2;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('material-ui/styles');

var _List = require('../../../../../../view/List');

var _Object = require('../../../../../ChatMessages/View/Object');

var _Object2 = _interopRequireDefault(_Object);

var _reactScroll = require('react-scroll');

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
} // import * as Scroll from 'react-scroll';
// import { Link, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'


var styles = function styles(theme) {
  var _defaultStyles = (0, _List.styles)(theme),
      root = _defaultStyles.root,
      other = _objectWithoutProperties(_defaultStyles, ['root']);

  return _extends({
    // root: {
    //   height: "100%",
    //   display: "flex",
    //   flexDirection: "column",
    //   // "& #chat-panel": {
    //   //   height: "100%",
    //   // },
    //   "& .active": {
    //     border: "1px solid green",
    //   },
    // },
    scrollContainer: {
      width: "100%",
      height: "100%",
      // flex: 1,
      overflowX: "hidden",
      overflowY: "auto",
      position: "relative"
    }
  }, other);
};

exports.styles = styles;
var TableView = exports.TableView = (_temp2 = _class = function (_TableViewProto) {
  _inherits(TableView, _TableViewProto);

  function TableView() {
    var _temp, _this, _ret;

    _classCallCheck(this, TableView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _TableViewProto.call.apply(_TableViewProto, [this].concat(args))), _this), _this.getScrollContainer = function () {
      return _this.scrollContainer;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  } // static propTypes = {
  //   ...TableViewProto.propTypes,
  // }


  TableView.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this; // console.log("TableView componentDidMount");


    _reactScroll.Events.scrollEvent.register('begin', function (to, element) {// console.log("begin", arguments);
    });

    _reactScroll.Events.scrollEvent.register('end', function (to, element) {// console.log("end", arguments);
    }); // scrollSpy.unmount(window.document);
    // scrollSpy.mount(this.getScrollContainer());


    _reactScroll.scrollSpy.update();

    setTimeout(function () {
      _this2.scrollToBottom();
    }, 300);
    _TableViewProto.prototype.componentDidMount && _TableViewProto.prototype.componentDidMount.call(this);
  };

  TableView.prototype.componentWillUnmount = function componentWillUnmount() {
    _reactScroll.Events.scrollEvent.remove('begin');

    _reactScroll.Events.scrollEvent.remove('end');
  };

  TableView.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this3 = this;

    var _ref = this.props.data || {},
        objectsConnection = _ref.objectsConnection;

    var _ref2 = prevProps.data || {},
        prevData = _ref2.objectsConnection; // console.log("componentDidUpdate", objectsConnection === prevData);


    if ((objectsConnection || prevData) && objectsConnection !== prevData) {
      setTimeout(function () {
        _this3.scrollToBottom();
      }, 300);
    }

    _TableViewProto.prototype.componentDidUpdate && _TableViewProto.prototype.componentDidUpdate.call(this, prevProps, prevState);
  };

  TableView.prototype.scrollToTop = function scrollToTop() {
    _reactScroll.animateScroll.scrollToTop({
      container: this.getScrollContainer()
    });
  };

  TableView.prototype.scrollToBottom = function scrollToBottom() {
    _reactScroll.animateScroll.scrollToBottom({
      container: this.getScrollContainer()
    });
  };

  TableView.prototype.scrollTo = function scrollTo() {
    _reactScroll.animateScroll.scrollTo(100, {
      container: this.getScrollContainer()
    });
  };

  TableView.prototype.scrollMore = function scrollMore() {
    _reactScroll.animateScroll.scrollMore(100, {
      container: this.getScrollContainer()
    });
  };

  TableView.prototype.handleSetActive = function handleSetActive(to) {// console.log("handleSetActive", to);
  };

  TableView.prototype.renderContent = function renderContent() {
    var _this4 = this;

    var _props = this.props,
        _props$data = _props.data,
        loading = _props$data.loading,
        objectsConnection = _props$data.objectsConnection,
        classes = _props.classes;
    var _context = this.context,
        Grid = _context.Grid,
        updateChatMessageProcessor = _context.query.updateChatMessageProcessor,
        currentUser = _context.user;

    var _ref3 = currentUser || {},
        currentUserId = _ref3.id;

    var messages = void 0;
    var items = [];
    messages = objectsConnection && objectsConnection.edges.map(function (_ref4) {
      var node = _ref4.node;
      return node;
    }).map(function (n, index) {
      // const {
      //   id,
      //   contentText: message,
      //   CreatedBy,
      // } = n;
      // const {
      //   id: createdById,
      //   fullname,
      //   username,
      // } = CreatedBy;
      // return new Message({
      //   id: currentUserId && currentUserId === createdById ? 0 : 1,
      //   message,
      //   senderName: fullname || username,
      // })
      // items.push(<Grid
      //   key={n.id}
      //   item
      // >
      //   <Link
      //     activeClass="active"
      //     to={n.id}
      //     spy={true}
      //     smooth={true}
      //     duration={500}
      //     onSetActive={this.handleSetActive}
      //     container={this.getScrollContainer()}
      //   >
      //     {n.id}
      //   </Link>
      // </Grid>);
      return _react2.default.createElement(_reactScroll.Element, {
        key: n.id,
        name: n.id
      }, _react2.default.createElement(_Object2.default, {
        data: {
          object: n
        },
        mutate: function mutate(props) {
          return _this4.mutate(_extends({
            mutation: (0, _graphqlTag2.default)(updateChatMessageProcessor)
          }, props));
        }
      }));
    }) || []; // messages = [];

    return _react2.default.createElement('div', {
      className: classes.scrollContainer,
      ref: function ref(element) {
        _this4.scrollContainer = element;
      }
    }, messages); // return (
    //   <div
    //     className={classes.root}
    //   >
    //     <div
    //       className={classes.links}
    //     >
    //       <Grid
    //         container
    //         spacing={8}
    //       >
    //         {items}
    //       </Grid>
    //     </div>
    //     <div
    //       className={classes.scrollContainer}
    //       ref={element => {
    //         this.scrollContainer = element;
    //       }}
    //     >
    //       {messages}
    //     </div>
    //   </div>
    // );
  };

  return TableView;
}(_List.TableView), _class.defaultProps = _extends({}, _List.TableView.defaultProps, {
  title: ""
}), _temp2);
exports.default = (0, _styles.withStyles)(styles)(function (props) {
  return _react2.default.createElement(TableView, props);
});